/*
 * Import inside your main index.js or init function.
 * Ensure 'duconData' is localized in functions.php
 */
export function initLoadMore() {
  (function ($) {
    const $loadBtn = $("#load-more");
    const $grid = $("#blog-grid");

    if (!$loadBtn.length) return;

    $loadBtn.on("click", function () {
      const $btn = $(this);

      // Get current page and max pages from data attributes
      let currentPage = parseInt($btn.data("page"));
      const maxPages = parseInt($btn.data("max"));
      const nextPage = currentPage + 1;

      // UX: Loading State
      const originalText = $btn.text();
      $btn.text("Loading...").addClass("opacity-50 pointer-events-none");

      $.ajax({
        url: duconData.ajaxurl, // Defined in functions.php
        type: "POST",
        data: {
          action: "load_more_posts",
          page: nextPage,
          nonce: duconData.nonce,
        },
        success: function (response) {
          if (response) {
            // Append new posts
            const $newContent = $(response).hide();
            $grid.append($newContent);
            $newContent.fadeIn(400);

            // Update Page Count
            $btn.data("page", nextPage);
            $btn
              .text(originalText)
              .removeClass("opacity-50 pointer-events-none");

            // Hide button if we reached the end
            if (nextPage >= maxPages) {
              $("#load-more-wrapper").fadeOut();
            }
          } else {
            $("#load-more-wrapper").fadeOut();
          }
        },
        error: function () {
          console.error("Error loading posts.");
          $btn.text("Error").removeClass("opacity-50 pointer-events-none");
        },
      });
    });
  })(jQuery);
}
